import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { defaultStoreNoSearchDTO } from '@utils/store';

import { TDefaultStoreNoSearchDTO } from '@interfaces/common/store';

import { defaultMeta } from '../enums/common';

interface IInitialState extends TDefaultStoreNoSearchDTO {
	gnbId: string | null;
	version: string | null;
	configId: string | null;
	type: string | null;
	date: number | null;
}

const initialState: IInitialState = {
	sortDirection: false,
	sortFieldName: null,
	gnbId: null,
	version: null,
	configId: null,
	type: null,
	date: null,
	...defaultMeta,
};

const dataSourceGNBConfiguration = createSlice({
	name: 'dataSourceGNBConfiguration',
	initialState,
	reducers: {
		...defaultStoreNoSearchDTO,
		setGNBId: (state, action: PayloadAction<{ gnbId: string }>) => {
			state.gnbId = action.payload.gnbId;
			state.page = initialState.page;
		},
		setReleaseVersion: (state, action: PayloadAction<{ version: string }>) => {
			state.version = action.payload.version;
			state.page = initialState.page;
		},
		setConfigType: (state, action: PayloadAction<{ type: string }>) => {
			state.type = action.payload.type;
			state.page = initialState.page;
		},
		setConfigId: (state, action: PayloadAction<{ configId: string }>) => {
			state.configId = action.payload.configId;
			state.page = initialState.page;
		},
		setDate: (state, action: PayloadAction<{ date: number | null }>) => {
			state.date = action.payload.date;
			state.page = initialState.page;
		},
		resetDataSourceGNBConfiguration: () => initialState,
	},
});

export const {
	resetDataSourceGNBConfiguration,
	setSort,
	setPage,
	setPageSize,
	setGNBId,
	setReleaseVersion,
	setConfigType,
	setConfigId,
	setDate,
} = dataSourceGNBConfiguration.actions;

export default dataSourceGNBConfiguration.reducer;
